module.exports = __webpack_public_path__ + "img/Villa_Borna_43.b4881431.jpg";